(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ctr-buy-box-autoship-dual"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindDualPlan = (root) => {
      if (!root || root.dataset.ctrDualPlanBound === 'true') return;

      const radios = root.querySelectorAll('[data-ctr-dual-plan-radio]');
      const buyBox = root.closest('.ctr-buy-box');
      const cta = buyBox ? buyBox.querySelector('[data-ctr-dual-plan-cta]') : null;
      if (!radios.length || !cta || !buyBox) return;

      root.dataset.ctrDualPlanBound = 'true';

      const mainImage = buyBox.querySelector('[data-ctr-buy-box-gallery-main]');
      const thumbImage = buyBox.querySelector('[data-ctr-buy-box-gallery-thumb]');
      const defaultSrc = buyBox.dataset.defaultGallerySrc || '';
      const defaultThumb = buyBox.dataset.defaultGalleryThumb || '';
      const defaultAlt = buyBox.dataset.defaultGalleryAlt || '';

      const preloadGalleryImages = () => {
        const urls = new Set();
        if (defaultSrc) urls.add(defaultSrc);
        if (defaultThumb) urls.add(defaultThumb);
        radios.forEach((radio) => {
          if (radio.dataset.gallerySrc) urls.add(radio.dataset.gallerySrc);
          if (radio.dataset.galleryThumb) urls.add(radio.dataset.galleryThumb);
        });
        urls.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      };

      const syncCta = () => {
        const selected = root.querySelector('[data-ctr-dual-plan-radio]:checked');
        const permalink = selected && selected.dataset.permalink ? selected.dataset.permalink.trim() : '';

        if (permalink) {
          cta.setAttribute('href', permalink);
          cta.removeAttribute('aria-disabled');
          cta.removeAttribute('tabindex');
          cta.classList.remove('is-disabled');
        } else {
          cta.setAttribute('href', '#');
          cta.setAttribute('aria-disabled', 'true');
          cta.setAttribute('tabindex', '-1');
          cta.classList.add('is-disabled');
        }
      };

      const syncGallery = () => {
        const selected = root.querySelector('[data-ctr-dual-plan-radio]:checked');
        const gallerySrc = (selected && selected.dataset.gallerySrc) || defaultSrc;
        const galleryThumb = (selected && selected.dataset.galleryThumb) || defaultThumb;
        const galleryAlt = (selected && selected.dataset.galleryAlt) || defaultAlt;

        if (mainImage && gallerySrc) {
          mainImage.src = gallerySrc;
          mainImage.srcset = '';
          if (galleryAlt) mainImage.alt = galleryAlt;

          const gallery = buyBox.buyBoxGallery;
          if (gallery && gallery.mainSlider) {
            gallery.mainSlider.slideTo(0);
            const updateHeight = () => gallery.mainSlider.updateAutoHeight(300);
            if (mainImage.complete) {
              updateHeight();
            } else {
              mainImage.addEventListener('load', updateHeight, { once: true });
            }
          }
        }

        if (thumbImage && galleryThumb) {
          thumbImage.src = galleryThumb;
          if (galleryAlt) thumbImage.alt = galleryAlt;
        }
      };

      const syncSelection = () => {
        syncCta();
        syncGallery();
      };

      radios.forEach((radio) => {
        radio.addEventListener('change', syncSelection);
      });

      cta.addEventListener('click', (event) => {
        if (cta.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
        }
      });

      preloadGalleryImages();
      syncSelection();
    };

    const initAll = () => {
      document.querySelectorAll('[data-ctr-dual-plan]').forEach(bindDualPlan);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-ctr-dual-plan]');
      if (root) bindDualPlan(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctr-buy-box-autoship-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bind = (root) => {
      if (!root || root.dataset.ctrV2Bound === 'true') return;
      const buyBox = root.closest('.ctr-buy-box');
      const radios = root.querySelectorAll('[data-ctr-v2-plan-radio]');
      const cta = buyBox ? buyBox.querySelector('[data-ctr-v2-cta]') : null;
      const note = buyBox ? buyBox.querySelector('[data-ctr-v2-cta-note]') : null;
      if (!buyBox || !radios.length || !cta) return;
      root.dataset.ctrV2Bound = 'true';

      const mainImage = buyBox.querySelector('[data-ctr-buy-box-gallery-main]');
      const thumbImage = buyBox.querySelector('[data-ctr-buy-box-gallery-thumb]');
      const defaults = {
        src: buyBox.dataset.defaultGallerySrc || '',
        thumb: buyBox.dataset.defaultGalleryThumb || '',
        alt: buyBox.dataset.defaultGalleryAlt || ''
      };

      const sync = () => {
        const selected = root.querySelector('[data-ctr-v2-plan-radio]:checked');
        if (!selected) return;
        const d = selected.dataset;

        const permalink = (d.permalink || '').trim();
        if (permalink) {
          cta.setAttribute('href', permalink);
          cta.removeAttribute('aria-disabled');
          cta.removeAttribute('tabindex');
          cta.classList.remove('is-disabled');
        } else {
          cta.setAttribute('href', '#');
          cta.setAttribute('aria-disabled', 'true');
          cta.setAttribute('tabindex', '-1');
          cta.classList.add('is-disabled');
        }
        if (d.ctaLabel) cta.textContent = d.ctaLabel;
        if (note) {
          note.textContent = d.ctaNote || '';
          note.hidden = !d.ctaNote;
        }

        const src = d.gallerySrc || defaults.src;
        const thumb = d.galleryThumb || defaults.thumb;
        const alt = d.galleryAlt || defaults.alt;
        if (mainImage && src && mainImage.getAttribute('src') !== src) {
          mainImage.src = src;
          mainImage.srcset = '';
          if (alt) mainImage.alt = alt;
          const gallery = buyBox.buyBoxGallery;
          if (gallery && gallery.mainSlider) {
            gallery.mainSlider.slideTo(0);
            const h = () => gallery.mainSlider.updateAutoHeight(300);
            mainImage.complete ? h() : mainImage.addEventListener('load', h, { once: true });
          }
        }
        if (thumbImage && thumb) {
          thumbImage.src = thumb;
          if (alt) thumbImage.alt = alt;
        }

        document.dispatchEvent(new CustomEvent('ctr-v2:plan-change', { detail: { href: permalink } }));
      };

      radios.forEach((r) => r.addEventListener('change', sync));
      cta.addEventListener('click', (e) => {
        if (cta.getAttribute('aria-disabled') === 'true') e.preventDefault();
      });
      sync();
    };

    // Gift popup: open on the welcome kit row, close on X, backdrop or Esc
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-ctr-v2-gift-open]');
      if (opener) {
        e.preventDefault();
        e.stopPropagation();
        const dlg = document.getElementById(opener.dataset.ctrV2GiftOpen);
        if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
          dlg.showModal();
          dlg._opener = opener;
        }
        return;
      }
      const closer = e.target.closest('[data-ctr-v2-gift-close]');
      const dlg = closer ? closer.closest('dialog') : (e.target.matches && e.target.matches('dialog.ctr-v2gift') ? e.target : null);
      if (dlg && dlg.open) {
        dlg.close();
        if (dlg._opener) dlg._opener.focus();
      }
    });

    // Apps (e.g. a promo/countdown widget) that inject themselves between the
    // plans and the button get moved under the button so the CTA leads.
    const relocatePromos = (buyBox) => {
      const plans = buyBox.querySelector('[data-ctr-v2-plan]');
      const checkout = buyBox.querySelector('[data-ctr-v2-checkout]');
      const slot = buyBox.querySelector('[data-ctr-v2-after-cta]');
      if (!plans || !checkout || !slot || plans.parentElement !== checkout.parentElement) return;
      let node = plans.nextElementSibling;
      while (node && node !== checkout) {
        const next = node.nextElementSibling;
        if (node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') slot.appendChild(node);
        node = next;
      }
    };

    const watchPromos = (buyBox) => {
      if (buyBox.dataset.ctrV2PromoWatch === 'true') return;
      buyBox.dataset.ctrV2PromoWatch = 'true';
      relocatePromos(buyBox);
      const parent = buyBox.querySelector('[data-ctr-v2-checkout]');
      if (!parent || !('MutationObserver' in window)) return;
      new MutationObserver(() => relocatePromos(buyBox)).observe(parent.parentElement, { childList: true });
    };

    const init = () => {
      document.querySelectorAll('[data-ctr-v2-plan]').forEach(bind);
      document.querySelectorAll('.ctr-buy-box-v2').forEach(watchPromos);
    };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target.querySelector('[data-ctr-v2-plan]');
      if (root) bind(root);
      const box = e.target.querySelector('.ctr-buy-box-v2');
      if (box) watchPromos(box);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctr-countdown-bar-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');

    const endFor = (bar) => {
      if (bar.dataset.mode === 'fixed') {
        const t = Date.parse(bar.dataset.end || '');
        return Number.isNaN(t) ? null : t;
      }
      const next = new Date();
      next.setHours(24, 0, 0, 0);
      return next.getTime();
    };

    const start = (bar) => {
      if (bar.dataset.ctrCdbarBound === 'true') return;
      bar.dataset.ctrCdbarBound = 'true';
      const h = bar.querySelector('[data-h]');
      const m = bar.querySelector('[data-m]');
      const s = bar.querySelector('[data-s]');
      let end = endFor(bar);

      const tick = () => {
        if (end === null) return;
        let left = end - Date.now();
        if (left <= 0) {
          if (bar.dataset.mode === 'fixed') {
            if (bar.dataset.hideExpired === 'true') bar.hidden = true;
            h.textContent = m.textContent = s.textContent = '00';
            clearInterval(timer);
            return;
          }
          end = endFor(bar);
          left = end - Date.now();
        }
        const total = Math.floor(left / 1000);
        h.textContent = pad(Math.floor(total / 3600));
        m.textContent = pad(Math.floor((total % 3600) / 60));
        s.textContent = pad(total % 60);
      };

      const timer = setInterval(tick, 1000);
      tick();
    };

    const init = () => document.querySelectorAll('[data-ctr-cdbar]').forEach(start);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctr-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__howItWorksVideoBound) return;
    window.__howItWorksVideoBound = true;

    const initSection = (section) => {
      const videoSteps = section.querySelectorAll('[data-video-step]');
      if (!videoSteps.length) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const setPlayingState = (step, isPlaying) => {
        if (isPlaying) {
          step.classList.add('is-playing');
        } else {
          step.classList.remove('is-playing');
        }
      };

      const syncVideoAria = (video) => {
        video.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      };

      const toggleVideo = async (video) => {
        if (video.paused) {
          try {
            await video.play();
          } catch (error) {
            console.warn('How It Works video play failed', error);
          }
        } else {
          video.pause();
        }
      };

      for (const step of videoSteps) {
        const video = step.querySelector('[data-how-it-works-video]');
        const playButton = step.querySelector('[data-how-it-works-play]');
        if (!video || !playButton) continue;

        syncVideoAria(video);

        playButton.addEventListener('click', async () => {
          try {
            await video.play();
          } catch (error) {
            console.warn('How It Works video play failed', error);
          }
        });

        video.addEventListener('click', () => {
          toggleVideo(video);
        });

        video.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          toggleVideo(video);
        });

        video.addEventListener('play', () => {
          setPlayingState(step, true);
          syncVideoAria(video);
        });
        video.addEventListener('pause', () => {
          setPlayingState(step, false);
          syncVideoAria(video);
        });
        video.addEventListener('ended', () => {
          setPlayingState(step, false);
          syncVideoAria(video);
        });
      }

      if (reducedMotion || !('IntersectionObserver' in window)) return;

      const autoplaySteps = Array.from(videoSteps).filter(
        (step) => step.getAttribute('data-autoplay') === 'true'
      );

      if (!autoplaySteps.length) return;

      const observer = new IntersectionObserver(
        (entries, io) => {
          for (const entry of entries) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.5) continue;
            const step = entry.target;
            if (step.dataset.autoplayTriggered === 'true') {
              io.unobserve(step);
              continue;
            }
            const video = step.querySelector('[data-how-it-works-video]');
            if (!video) {
              io.unobserve(step);
              continue;
            }

            video
              .play()
              .then(() => {
                step.dataset.autoplayTriggered = 'true';
                setPlayingState(step, true);
                io.unobserve(step);
              })
              .catch(() => {
                io.unobserve(step);
              });
          }
        },
        {
          threshold: [0.5]
        }
      );

      for (const step of autoplaySteps) {
        observer.observe(step);
      }
    };

    const sections = document.querySelectorAll('.shopify-section .how-it-works');
    for (const section of sections) {
      initSection(section);
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.how-it-works');
      if (section) {
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctr-sale-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MS_DAY = 86400000;
    const MS_HOUR = 3600000;
    const MS_MIN = 60000;
    const MS_SEC = 1000;
    const timers = new Map();

    const pad = (value) => String(value).padStart(2, '0');

    const getEndTime = (banner) => {
      const minutes = parseInt(banner.dataset.countdownMinutes, 10) || 15;

      if (window.CtrSessionCountdown) {
        return window.CtrSessionCountdown.getEndTime(minutes);
      }

      const fallbackKey = 'ctr-session-countdown-end';
      const now = Date.now();
      const stored = sessionStorage.getItem(fallbackKey);
      if (stored) {
        const end = parseInt(stored, 10);
        if (!Number.isNaN(end) && end > now) return end;
      }

      const end = now + minutes * 60 * 1000;
      sessionStorage.setItem(fallbackKey, String(end));
      return end;
    };

    const getTimeParts = (remaining) => {
      const safeRemaining = Math.max(0, remaining);
      const days = Math.floor(safeRemaining / MS_DAY);
      const hours = Math.floor((safeRemaining % MS_DAY) / MS_HOUR);
      const minutes = Math.floor((safeRemaining % MS_HOUR) / MS_MIN);
      const seconds = Math.floor((safeRemaining % MS_MIN) / MS_SEC);

      return {
        days,
        hours,
        minutes,
        seconds,
        showDays: safeRemaining >= MS_DAY,
        expired: remaining <= 0
      };
    };

    const formatAriaLabel = (banner, parts) => {
      const labelDays = banner.dataset.labelDays || 'days';
      const labelHours = banner.dataset.labelHours || 'hours';
      const labelMinutes = banner.dataset.labelMinutes || 'minutes';
      const labelSeconds = banner.dataset.labelSeconds || 'seconds';
      const segments = [];

      if (parts.showDays) {
        segments.push(`${parts.days} ${labelDays}`);
      }

      segments.push(
        `${parts.hours} ${labelHours}`,
        `${parts.minutes} ${labelMinutes}`,
        `${parts.seconds} ${labelSeconds}`
      );

      return `${segments.join(', ')} remaining`;
    };

    const updateBanner = (banner) => {
      const endTime = getEndTime(banner);
      const timerEl = banner.querySelector('.ctr-sale-countdown-banner__timer');
      const daysUnit = banner.querySelector('[data-days-unit]');
      const daysSeparator = banner.querySelector('[data-days-separator]');
      const daysEl = banner.querySelector('[data-days]');
      const hoursEl = banner.querySelector('[data-hours]');
      const minutesEl = banner.querySelector('[data-minutes]');
      const secondsEl = banner.querySelector('[data-seconds]');

      if (!timerEl || !hoursEl || !minutesEl || !secondsEl) {
        return;
      }

      const parts = getTimeParts(endTime - Date.now());

      if (daysUnit && daysSeparator && daysEl) {
        daysUnit.hidden = !parts.showDays;
        daysSeparator.hidden = !parts.showDays;
        daysEl.textContent = pad(parts.days);
      }

      hoursEl.textContent = pad(parts.hours);
      minutesEl.textContent = pad(parts.minutes);
      secondsEl.textContent = pad(parts.seconds);
      timerEl.setAttribute('aria-label', formatAriaLabel(banner, parts));
    };

    const clearBannerTimer = (banner) => {
      const intervalId = timers.get(banner);
      if (intervalId) {
        clearInterval(intervalId);
        timers.delete(banner);
      }
    };

    const initBanner = (banner) => {
      clearBannerTimer(banner);
      updateBanner(banner);

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const intervalMs = reducedMotion ? 60000 : 1000;

      const intervalId = setInterval(() => updateBanner(banner), intervalMs);
      timers.set(banner, intervalId);
    };

    const initAll = (root = document) => {
      const banners = root.querySelectorAll('.ctr-sale-countdown-banner');
      for (const banner of banners) {
        initBanner(banner);
      }
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const banners = event.target.querySelectorAll('.ctr-sale-countdown-banner');
      for (const banner of banners) {
        clearBannerTimer(banner);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-flush-bundle"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const q = selector => root.querySelector(selector);
    const thumbs = [...root.querySelectorAll('.thumb')];
    const image = q('.gallery-main > img');
    const count = q('.gallery-count');
    let current = 0;
    function show(index) {
      current = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[current];
      image.removeAttribute('srcset');
      image.src = thumb.dataset.src;
      image.alt = thumb.dataset.alt;
      thumbs.forEach((item, i) => {
        item.classList.toggle('active', i === current);
        item.setAttribute('aria-pressed', String(i === current));
      });
      count.textContent = `${current + 1} / ${thumbs.length}`;
    }
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i), {signal}));
    q('.gal-prev').addEventListener('click', () => show(current - 1), {signal});
    q('.gal-next').addEventListener('click', () => show(current + 1), {signal});
    q('.gallery').addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    }, {signal});
    const sticky = q('.sticky');
    const hero = q('[data-hero]');
    const offer = q('[data-offer]');
    const track = q('.review-track');
    const reviewSection = q('.reviews-section');
    const progress = q('.review-progress span');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let manualUntil = 0;
    let frame = 0;
    function updateProgress() {
      progress.style.width = `${Math.min(100, (track.scrollLeft + track.clientWidth) / Math.max(track.scrollWidth, 1) * 100)}%`;
    }
    function moveReviews(direction) {
      manualUntil = Date.now() + 15000;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      track.scrollBy({left: direction * (track.querySelector('.review-card').getBoundingClientRect().width + gap), behavior: reducedMotion.matches ? 'instant' : 'smooth'});
    }
    q('[data-reviews-prev]').addEventListener('click', () => moveReviews(-1), {signal});
    q('[data-reviews-next]').addEventListener('click', () => moveReviews(1), {signal});
    track.addEventListener('pointerdown', () => {manualUntil = Date.now() + 15000;}, {passive:true, signal});
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); moveReviews(event.key === 'ArrowRight' ? 1 : -1);
      }
    }, {signal});
    track.addEventListener('scroll', updateProgress, {passive:true, signal});
    function update() {
      frame = 0;
      const offerBox = offer.getBoundingClientRect();
      const showSticky = hero.getBoundingClientRect().bottom < 100 && !(offerBox.top < innerHeight - 100 && offerBox.bottom > 100);
      sticky.classList.toggle('on', showSticky);
      sticky.toggleAttribute('inert', !showSticky);
      if (!reducedMotion.matches && Date.now() > manualUntil) {
        const box = reviewSection.getBoundingClientRect();
        if (box.top < innerHeight * .8 && box.bottom > innerHeight * .2) {
          const fraction = Math.max(0, Math.min(1, (innerHeight * .8 - box.top) / (box.height + innerHeight * .3)));
          track.scrollLeft = fraction * (track.scrollWidth - track.clientWidth);
        }
      }
      updateProgress();
    }
    function schedule() {if (!frame) frame = requestAnimationFrame(update);}
    window.addEventListener('scroll', schedule, {passive:true, signal});
    window.addEventListener('resize', schedule, {passive:true, signal});
    root.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#sh-"]');
      if (!anchor) return;
      const id = anchor.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (target && root.contains(target)) {
        event.preventDefault(); target.scrollIntoView({behavior: reducedMotion.matches ? 'instant' : 'smooth', block:'start'});
      }
    }, {signal});
    const videos = [...root.querySelectorAll('video')];
    videos.forEach(video => {video.muted = true; video.loop = true;});
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => entries.forEach(({target, isIntersecting}) => {
        if (isIntersecting && !reducedMotion.matches) target.play().catch(() => {});
        else target.pause();
      }), {threshold:.2});
      videos.forEach(video => observer.observe(video));
    }
    if (reducedMotion.matches) videos.forEach(video => {video.autoplay = false; video.pause();});
    reducedMotion.addEventListener('change', () => {
      videos.forEach(video => {
        if (reducedMotion.matches) video.pause();
        else if (video.getBoundingClientRect().top < innerHeight && video.getBoundingClientRect().bottom > 0) video.play().catch(() => {});
      });
    }, {signal});
    instances.set(root, () => {controller.abort(); observer?.disconnect(); if (frame) cancelAnimationFrame(frame);});
    update();
  }
  function scan(scope = document) {
    if (scope.matches?.('[data-sh-flush-bundle]')) init(scope);
    scope.querySelectorAll('[data-sh-flush-bundle]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once:true});
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) {
      if (event.target.contains(root)) {cleanup(); instances.delete(root);}
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
